import React from 'react'
import {Row, Col, InlineLoader} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'

import DynamicEntriesTable, {DynamicEntry} from '../../../../component/dynamic-entries-table'
import SummaryPageFooter from '../../components/summary-page-footer'
import {FormContentWrapper} from '../../../../ui/form'
import {StyledImg, ImageContainer} from '../../../summary-page-image/styles'
import {StyledParagraph} from '../../../../ui/styles'
import SummaryPageHeader from '../../components/summary-page-header'
import {SECTION_DIRECTORS} from '../../../../constants/sections'

const tableHeadlines = ['name', 'position']

/** One row of the DirectorSummaryPage table. */
type DirectorSummaryEntry = DynamicEntry & {
  route: string
  name: string
  position: string
}

export type DirectorSummaryPageProps = {
  isLoading: boolean
  directorSummary: DirectorSummaryEntry[]
  isReadonly: boolean
  createDirector: () => void
}

const DirectorSummaryPage: React.FC<DirectorSummaryPageProps> = ({
  isLoading,
  directorSummary,
  isReadonly,
  createDirector,
}) => {
  const {t} = useTranslation('charon')

  return (
    <>
      <FormContentWrapper>
        <SummaryPageHeader
          ctaText={t(`director-summary-page.create.CTA`)}
          onCreate={createDirector}
          isDisabled={isReadonly}
        />
        {isLoading && (
          <Row>
            <Col>
              <InlineLoader />
            </Col>
          </Row>
        )}
        {!isLoading && directorSummary.length < 1 && (
          <>
            <Row justifyContent="center">
              <Col auto>
                <ImageContainer>
                  <StyledImg src="/assets/images/no-results-dynamic-entries.png" alt="no-results" />
                </ImageContainer>
              </Col>
            </Row>
            <Row justifyContent="center">
              <Col auto>
                <StyledParagraph>{t('director-summary-page.no-results.message')}</StyledParagraph>
              </Col>
            </Row>
          </>
        )}
        {!isLoading && directorSummary.length > 0 && (
          <Row mb={40}>
            <Col>
              <DynamicEntriesTable
                dataList={directorSummary || []}
                headlines={tableHeadlines}
                transPrefix="director-summary"
              />
            </Col>
          </Row>
        )}
      </FormContentWrapper>

      <SummaryPageFooter sectionName={SECTION_DIRECTORS} />
    </>
  )
}

export default DirectorSummaryPage
